import { CardCtaItems } from '../models/cards-cta-items.model';
import { ActionType } from '@client-monorepo/common/action-handler';
import { StatusLightBordersEnum, StatusLightColorsEnum, StatusLightSizesEnum } from '@client-monorepo/common/ui-components';
import { FrequentServicesIdEnum } from '@client-monorepo/common/service-data';

export enum CardCtaItemType {
  C2C = 'C2C',
  ADD_CARD = 'ADD_CARD',
  QR = 'QR',
  BARCODE_BUY = 'BARCODE_BUY',
  DETAILS = 'DETAILS',
  CONNECT_CARD_TO_CREDIT = 'CONNECT_CARD_TO_CREDIT',
  MANAGE_CARDS = 'MANAGE_CARDS',
  MY_CARDS = 'MY_CARDS',
  INSTALLMENT = 'INSTALLMENT',
  BNPL_INSTALLMENT = 'BNPL_INSTALLMENT',
  STORES = 'STORES',
  CASH_IN = 'CASH_IN',
  CASH_OUT = 'CASH_OUT',
  ADD_GIFT_CARD = 'ADD_GIFT_CARD',
  TRANSFER = 'TRANSFER',
  MORE = 'MORE',
}

export const CardCtaItemTitleMapper: Record<CardCtaItemType, string> = {
  [CardCtaItemType.C2C]: 'کارت‌به‌کارت',
  [CardCtaItemType.ADD_CARD]: 'افزودن کارت',
  [CardCtaItemType.QR]: 'بارکد‌خوان',
  [CardCtaItemType.DETAILS]: 'جزییات',
  [CardCtaItemType.BARCODE_BUY]: 'خرید با بارکد',
  [CardCtaItemType.MANAGE_CARDS]: 'مدیریت کارت‌ها',
  [CardCtaItemType.MY_CARDS]: 'کارت‌های‌من',
  [CardCtaItemType.CONNECT_CARD_TO_CREDIT]: 'اتصال به وام',
  [CardCtaItemType.INSTALLMENT]: 'اقساط',
  [CardCtaItemType.BNPL_INSTALLMENT]: 'اقساط',
  [CardCtaItemType.STORES]: 'فروشگاه‌ها',
  [CardCtaItemType.CASH_IN]: 'شارژ کیف',
  [CardCtaItemType.CASH_OUT]: 'برداشت',
  [CardCtaItemType.ADD_GIFT_CARD]: 'افزودن کد هدیه',
  [CardCtaItemType.TRANSFER]: 'انتقال',
  [CardCtaItemType.MORE]: 'بیشتر',
};

export const CardCtaItemMapper: Record<CardCtaItemType, CardCtaItems> = {
  [CardCtaItemType.C2C]: {
    name: CardCtaItemTitleMapper[CardCtaItemType.C2C],
    icon: {
      name: 'card-to-card',
      type: 'linear',
    },
    action: {
      type: ActionType.GO_TO_C2C,
      payload: {
        cardNumber: '',
      },
    },
    isHighlighted: true,
    isDisabled: false,
    hasNotification: false,
    hasChildren: false,
  },
  [CardCtaItemType.ADD_CARD]: {
    name: CardCtaItemTitleMapper[CardCtaItemType.ADD_CARD],
    icon: {
      name: 'Bank-Card',
      type: 'linear',
    },
    action: {
      type: ActionType.REDIRECT,
      payload: {
        url: 'profile/saved-cards/add/source',
      },
    },
    isHighlighted: false,
    isDisabled: false,
    hasNotification: false,
    hasChildren: false,
  },
  [CardCtaItemType.QR]: {
    name: CardCtaItemTitleMapper[CardCtaItemType.QR],
    icon: {
      name: 'qr-scan',
      type: 'linear',
      secondColor: '#4c4c4c',
    },
    action: {
      type: ActionType.REDIRECT,
      payload: {
        url: 'qr',
      },
    },
    isHighlighted: false,
    hasNotification: false,
    isDisabled: false,
    hasChildren: false,
  },
  [CardCtaItemType.BARCODE_BUY]: {
    name: CardCtaItemTitleMapper[CardCtaItemType.BARCODE_BUY],
    icon: {
      name: 'barcode-scan',
      type: 'linear',
      secondColor: '#4c4c4c',
    },
    action: {
      type: ActionType.REDIRECT,
      payload: {
        url: 'barcode',
      },
    },
    isHighlighted: false,
    hasNotification: false,
    isDisabled: false,
    hasChildren: false,
  },
  [CardCtaItemType.DETAILS]: {
    name: CardCtaItemTitleMapper[CardCtaItemType.DETAILS],
    icon: {
      name: 'Info-menu',
      type: 'linear',
      secondColor: '#4c4c4c',
    },
    action: {
      type: ActionType.GO_TO_SERVICE,
      payload: {
        serviceId: FrequentServicesIdEnum.C2C,
      },
    },
    isHighlighted: false,
    hasNotification: false,
    isDisabled: false,
    hasChildren: false,
  },
  [CardCtaItemType.CONNECT_CARD_TO_CREDIT]: {
    name: CardCtaItemTitleMapper[CardCtaItemType.CONNECT_CARD_TO_CREDIT],
    icon: {
      name: 'link',
      type: 'linear',
      secondColor: '#4c4c4c',
    },
    isHighlighted: false,
    isDisabled: false,
    hasNotification: false,
    hasChildren: false,
    action: {
      type: ActionType.REDIRECT,
      payload: {
        url: 'profile/saved-cards',
      },
    },
  },
  [CardCtaItemType.MANAGE_CARDS]: {
    name: CardCtaItemTitleMapper[CardCtaItemType.MANAGE_CARDS],
    icon: {
      name: 'Info-menu',
      type: 'linear',
      secondColor: '#4c4c4c',
    },
    isHighlighted: false,
    isDisabled: false,
    hasNotification: false,
    hasChildren: false,
    action: {
      type: ActionType.REDIRECT,
      payload: {
        url: 'profile/saved-cards',
      },
    },
  },
  [CardCtaItemType.MY_CARDS]: {
    name: CardCtaItemTitleMapper[CardCtaItemType.MY_CARDS],
    icon: {
      name: 'Info-menu',
      type: 'linear',
      secondColor: '#4c4c4c',
    },
    isHighlighted: false,
    isDisabled: false,
    hasNotification: false,
    hasChildren: false,
    action: {
      type: ActionType.REDIRECT,
      payload: {
        url: 'profile/saved-cards',
      },
    },
  },
  [CardCtaItemType.INSTALLMENT]: {
    name: CardCtaItemTitleMapper[CardCtaItemType.INSTALLMENT],
    icon: {
      name: 'Calendar',
      type: 'linear',
    },
    action: {
      type: ActionType.REDIRECT,
      payload: {
        url: 'service/credit/resolve',
        params: {
          closeServiceUrl: window.location.pathname,
        },
      },
    },
    isHighlighted: false,
    hasNotification: false,
    isDisabled: false,
    notification: {
      size: StatusLightSizesEnum.TWELVE,
      color: StatusLightColorsEnum.RED,
      border: StatusLightBordersEnum.WHITE,
    },
    hasChildren: false,
  },
  [CardCtaItemType.BNPL_INSTALLMENT]: {
    name: CardCtaItemTitleMapper[CardCtaItemType.BNPL_INSTALLMENT],
    icon: {
      name: 'Calendar',
      type: 'linear',
    },
    action: {
      type: ActionType.REDIRECT,
      payload: {
        url: 'service/bnpl/total-installments',
        params: {
          closeServiceUrl: window.location.pathname,
        },
      },
    },
    isHighlighted: false,
    hasNotification: false,
    isDisabled: false,
    notification: {
      size: StatusLightSizesEnum.TWELVE,
      color: StatusLightColorsEnum.RED,
      border: StatusLightBordersEnum.WHITE,
    },
    hasChildren: false,
  },
  [CardCtaItemType.STORES]: {
    name: CardCtaItemTitleMapper[CardCtaItemType.STORES],
    icon: {
      name: 'Bag',
      type: 'linear',
    },
    action: {
      type: ActionType.REDIRECT,
      payload: {
        url: 'stores',
      },
    },
    isHighlighted: false,
    hasNotification: false,
    isDisabled: false,
    hasChildren: false,
  },
  [CardCtaItemType.CASH_IN]: {
    name: CardCtaItemTitleMapper[CardCtaItemType.CASH_IN],
    icon: {
      name: 'Plus',
      type: 'linear',
    },
    action: {
      type: ActionType.REDIRECT,
      payload: {
        url: 'cash-in',
      },
    },
    isHighlighted: true,
    hasNotification: false,
    isDisabled: false,
    hasChildren: false,
  },
  [CardCtaItemType.CASH_OUT]: {
    name: CardCtaItemTitleMapper[CardCtaItemType.CASH_OUT],
    icon: {
      name: 'Arrow-up',
      type: 'linear',
    },
    action: {
      type: ActionType.REDIRECT,
      payload: {
        url: 'cash-out',
      },
    },
    isHighlighted: false,
    hasNotification: false,
    isDisabled: false,
    hasChildren: false,
  },
  [CardCtaItemType.ADD_GIFT_CARD]: {
    name: CardCtaItemTitleMapper[CardCtaItemType.ADD_GIFT_CARD],
    icon: {
      name: 'gift',
      type: 'linear',
      secondColor: '#4c4c4c',
    },
    action: {
      type: ActionType.REDIRECT,
      payload: {
        url: 'wallet-management',
      },
    },
    isHighlighted: false,
    hasNotification: false,
    isDisabled: false,
    hasChildren: false,
  },
  [CardCtaItemType.TRANSFER]: {
    name: CardCtaItemTitleMapper[CardCtaItemType.TRANSFER],
    action: {
      type: ActionType.REDIRECT,
      payload: {
        url: 'cash-out',
      },
    },
    icon: {
      name: 'Info-menu',
      type: 'linear',
      secondColor: '#4c4c4c',
    },
    isHighlighted: false,
    hasNotification: false,
    isDisabled: false,
    hasChildren: false,
  },
  [CardCtaItemType.MORE]: {
    name: CardCtaItemTitleMapper[CardCtaItemType.MORE],
    icon: {
      name: 'Info-menu',
      type: 'linear',
      secondColor: '#4c4c4c',
    },
    action: {
      type: ActionType.REDIRECT,
      payload: {
        url: '/',
      },
    },
    isHighlighted: false,
    hasNotification: false,
    isDisabled: false,
    hasChildren: false,
  },
};
